import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import * as ElIconModules from '@element-plus/icons'
import './assets/css/style.css'
import 'element-plus/dist/index.css'
import './assets/css/app.less'
import "./assets/js/rem.js"
import zhCn from 'element-plus/es/locale/lang/zh-cn'
const app= createApp(App)
import axios from './assets/js/axios'
app.config.globalProperties.$axios = axios;
for(let iconName in ElIconModules){
    app.component(iconName,ElIconModules[iconName])
}

import MapLoader from './assets/js/mapLoader';
MapLoader().then( (AMap) => {
        console.log("地图加载成功");
    },
    (e) => {
        console.log("地图加载失败", e);
    }
);

app.use(store).use(router).use(ElementPlus, {
    locale: zhCn,
}).mount('#app')
